query GetVersion {
  version
}
